<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card box-margin">
            <div class="card-header">
              <i class="fas fa-th-large"></i><span> Sueldo Base</span>
            </div>
            <div class="card-body">
              <div class="shortcode-html">
                <!-- Table Bordered -->

                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th><b>Sueldo Base</b></th>
                        <th><b>Acciones</b></th>
                      </tr>
                    </thead>

                    <tbody v-if="lista_sueldo_Base.length">
                      <tr v-for="(c, index) in lista_sueldo_Base" :key="index">
                        <td v-text="'$' + c.sueldo"></td>

                        <td>
                          <button
                            type="button"
                            class="btn btn-primary btn-circle mb-2"
                            @click="setObtenerSueldoBase(c)"
                          >
                            <i class="fa fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="3" align="center">
                          <h5>No se encontraron resultados...</h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <nav style="float: left">
                  Mostrando la página
                  <span v-text="pagination.current_page"></span> de
                  <span v-text="pagination.last_page"></span>
                </nav>
                <nav style="float: right">
                  <ul class="pagination singel-page flex-wrap">
                    <li class="page-item" v-if="pagination.current_page > 1">
                      <a
                        class="page-link"
                        @click.prevent="
                          cambiarPagina(pagination.current_page - 1)
                        "
                        href="#"
                        >Anterior</a
                      >
                    </li>
                    <li
                      class="page-item"
                      v-for="page in pagesNumber"
                      :key="page"
                      :class="[page == isActived ? 'active' : '']"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="cambiarPagina(page)"
                        v-text="page"
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      v-if="pagination.current_page < pagination.last_page"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="
                          cambiarPagina(pagination.current_page + 1)
                        "
                        >Siguiente</a
                      >
                    </li>
                  </ul>
                </nav>

                <!-- End Table Bordered -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--   Inicio modal Evidencia-------------------------------------------------------------->
      <div
        class="modal fade"
        :class="{ show: modalShow }"
        :style="modalShow ? mostrarModal : 'ocultarModal'"
      >
        <div class="modal-dialog modal-md modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                class="modal-title mt-0 font-16"
                id="myLargeModalLabel"
                v-text="tituloModal"
              >
                Registrar Evidencia
              </h5>
              <button
                type="button"
                @click="abrirModal"
                class="close"
                data-dismiss="modal"
                aria-hidden="true"
              >
                ×
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="LeadName">Sueldo Base</label>
                      <money
                        v-model="vaCreSueldoBase.cSueldo"
                        v-bind="money"
                        class="form-control"
                      ></money>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="setActualizarSueldoBase"
                v-text="nameButon"
              >
                Actualizar
              </button>
              <button
                type="button"
                class="btn btn-sm btn-secondary"
                @click="abrirModal"
              >
                Cerrar
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--   Fin modal Evidencia-------------------------------------------------------------->
    </div>
  </div>
</template>

<script>
import { alertasM } from "../../../util.js";
export default {
  props: ["ruta"],
  data() {
    return {
      lista_sueldo_Base: [],
      pagination: {
        total: 0,
        current_page: 0,
        per_page: 0,
        last_page: 0,
        from: 0,
        to: 0,
      },
      offset: 3,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      pag_mostrar: 5, //registros a mostrar por pagina tipo datable
      modalShow: false,

      mostrarModal: {
        display: "block",
        background: "#0000006b",
      },
      ocultarModal: {
        display: "none",
      },
      vaCreSueldoBase: {
        eId: 0,
        cSueldo: 0.0,
      },
      tituloModal: "",
      nameButon: "",
      actu_reg: 0, //0 registrar - 1 actualizar
      AsignarRolPermisosByUsuario: JSON.parse(
        localStorage.getItem("listRolPermisosByUsuario")
      ),
    };
  },
  mixins: [alertasM],

  computed: {
    isActived: function () {
      return this.pagination.current_page;
    },
    //Calcula los elementos de la paginación
    pagesNumber: function () {
      if (!this.pagination.to) {
        //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
        return []; //Array vacio
      }

      var from = this.pagination.current_page - this.offset;
      // console.log("bengy: ", from);
      if (from < 1) {
        //si la pagina actual es 0 entonces la igualamos  a uno
        from = 1;
      }
      //la suma de la variable rom + el doble de la varialbe offset
      var to = from + this.offset * 2;
      // console.log("bengy2: ", from);
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }

      var pagesArray = [];
      while (from <= to) {
        /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
        //Solucion
        if (
          (from >= this.pagination.current_page - 1) &
          (from <= this.pagination.current_page + 3)
        )
          pagesArray.push(from);
        from++;
      }
      return pagesArray;
    },
  },

  methods: {
    getListSueldoBase(page, pag_mostrar) {
      var url = "/sueldo-base-listar";
      this.openCargando(); //Activamos pantalla de carga de bloqueo
      axios
        .get(url, {
          params: {
            page: page,
            pag_mostrar: pag_mostrar,
          },
        })
        .then((res) => {
          var respuesta = res.data;
          this.lista_sueldo_Base = respuesta.sueldo.data;
          this.pagination = respuesta.pagination;
          this.openCargando(true); //Desactivamos ventana de carga de bloqueo
        })
        .catch((err) => {
          if (err.response.status == 401) {
            if (localStorage["authUser"]) {
              this.$router.push({ name: "login" });
              location.reload();
              localStorage.clear();
              this.openCargando(true); //Desactivamos ventana de carga de bloqueo
            }
          }
          console.error(err);
        });
    },

    cambiarPagina(page) {
      let me = this;
      //Actualiza la página actual
      me.pagination.current_page = page;
      //Envia la petición para visualizar la data de esa página
      me.getListSueldoBase(page, me.pag_mostrar);
    },

    abrirModal() {
      this.modalShow = !this.modalShow;

      if (this.modalShow == true) {
        this.tituloModal = "Registrar Suldo Base";
        this.actu_reg = 0;
        this.nameButon = "Guardar";
      } else {
        // this.aTipoDocumento = [];
        this.cleanVariables();
      }
    },

    cleanVariables() {
      this.vaCreSueldoBase.cSueldo = 0.0;
      this.vaCreSueldoBase.eId = 0;
    },

    setActualizarSueldoBase() {
      this.openCargando(); //Activamos ventana de carga de bloqueo
      var url = "/sueldo-basico/actualizar";

      axios
        .put(url, {
          id: this.vaCreSueldoBase.eId,
          sueldo: this.vaCreSueldoBase.cSueldo,
        })
        .then((res) => {
          this.cleanVariables(); //Limpiamos el form
          //this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          this.getListSueldoBase(1, this.pag_mostrar);
          this.modalShow = false;
          if (res.data.status) {
            this.notify(
              " Sueldo Basico actualizado con éxito",
              "",
              "top",
              "center",
              "fas fa-check-circle",
              "success",
              " flipInX",
              "flipOutX"
            );
          }
        })
        .catch((err) => {
          this.openCargando(true); //Desactivamos ventana de carga de bloqueo

          for (var key in err.response.data.errors) {
            this.notify(
              " " + err.response.data.errors[key],
              "",
              "top",
              "right",
              "fas fa-exclamation-triangle",
              "danger",
              "animated flipInX",
              "flipOutX"
            );
          }
          if (err.response.status == 401) {
            if (localStorage["authUser"]) {
              this.$router.push({ name: "login" });
              location.reload();
              localStorage.clear();
              this.openCargando(true); //Desactivamos ventana de carga de bloqueo
            }
          }
          console.error(err);
        });
    },

    setObtenerSueldoBase(data) {
      //console.warn(data);
      this.tituloModal = "Actualizar Sueldo Base";
      this.nameButon = "Actualizar";
      this.vaCreSueldoBase.eId = data.id;
      this.vaCreSueldoBase.cSueldo = data.sueldo;
      this.modalShow = true;
      this.actu_reg = 1;
    },
  },
  mounted() {
    this.getListSueldoBase(1, this.pag_mostrar);
  },
};
</script>

<style>
</style>
